exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-widget=AemExtUpdates] div.csas-document-category,\n[widget=AemExtUpdates] div.csas-document-category {\n  cursor: pointer;\n}\n", ""]);

// exports
